<template>
  <div class="monthly_feature">
    <ul>
      <li>
        <a
          href="javascript:void(0)"
          rel="popover"
          data-content="Excuses to invite others to church are eliminated with TrueLife.org invitation cards. Whether in pockets or wallets these durable cards stay presentable and ready to be handed to an unbeliever.  Click here to see a sample."
          :title="$t('pricing.feature.para0.title')"
        >
          <span>{{ message_cards }}</span> {{ $t('pricing.feature.para0.content') }}
        </a>
      </li>

      <li>
        <a
          href="javascript:void(0)"
          rel="popover"
          data-content="Excuses to invite others to church are eliminated with TrueLife.org invitation cards. Whether in pockets or wallets these durable cards stay presentable and ready to be handed to an unbeliever.  Click here to see a sample."
          :title="$t('pricing.feature.para1.title')"
        >
          {{ $t('pricing.feature.para1.content') }}
        </a>
      </li>

      <li>
        <a
          href="javascript:void(0)"
          rel="popover"
          data-content="Your church will have a license for one year to make use of the TrueLife.org trademark. You can use our name and logo on any print and media associated with your church for that year."
          :title="$t('pricing.feature.para2.title')"
        >
          {{ $t('pricing.feature.para2.content') }}
        </a>
      </li>

      <li>
        <a
          href="javascript:void(0)"
          rel="popover"
          data-content="Expect 60 to 70 percent of your members to invite someone to church after the first week’s introduction of TrueLife.org! Two percent typically share their faith or invite on a regular basis."
          :title="$t('pricing.feature.para3.title')"
        >
          {{ $t('pricing.feature.para3.content') }}
        </a>
      </li>

      <li>
        <a
          href="javascript:void(0)"
          rel="popover"
          data-content="The Church Finder Profile beautifully displays church information including pictures, service times, sermon audio, embed video options, links to your website and much more. Click here to see a sample."
          :title="$t('pricing.feature.para4.title')"
        >
          {{ $t('pricing.feature.para4.content') }}
        </a>
      </li>

      <li>
        <a
          href="javascript:void(0)"
          rel="popover"
          data-content="Our study guides inspire retention of the information covered in our films. These also can serve as great talking points for sermons, evangelism tips and apologetic training."
          :title="$t('pricing.feature.para5.title')"
        >
          {{ $t('pricing.feature.para5.content') }}
        </a>
      </li>

      <li>
        <a data-toggle="modal" href="#embeddmodal"> {{ $t('pricing.feature.para6.content') }}</a>
      </li>

      <li>
        <a
          href="javascript:void(0)"
          rel="popover"
          data-content="We have done our best to provide you with comprehensive sermon ideas and introduction strategies for TrueLife.org. Please remember our Implementation Strategy, which is included, is most crucial. "
          :title="$t('pricing.feature.para7.title')"
        >
          {{ $t('pricing.feature.para7.content') }}
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ['message_cards'],
};
</script>
<style lang="scss">
.monthly_feature {
  padding: 50px 80px;
  float: left;
  width: 100%;

  h6 {
    font-size: 26px;
    margin: 0;
    padding: 0;
  }
  ul {
    list-style: none;
    margin: 25px 0 37px 0;
    padding: 0;
    li {
      padding: 8px 0;
      font-size: 17px;
      color: #666666;
      position: relative;
      padding-left: 20px;
      font-family: 'Montserrat-Light';
      letter-spacing: 1;
      &:after {
        background-color: #333333;
        height: 11px;
        width: 11px;
        position: absolute;
        content: '';
        left: 0;
        top: 15px;
      }
    }
  }
}
@media only screen and (max-device-width: 596px) {
  .monthly_feature {
    padding: 10px 20px;
  }
}
</style>
